import {en} from './en'
import {es} from './es'
import {fr} from './fr'
import {nl} from './nl'

export default {nl, fr, en, es}
export type Language = typeof nl
